// ====================================================================
  // PRODUCT MAIN SECTION JAVASCRIPT
  // ====================================================================
  
  (function() {
    'use strict';

    const configElement = document.querySelector('script[data-product-main-config-0722]');
    if (!configElement) return;

    let productMainConfig = {};
    try {
      productMainConfig = JSON.parse(configElement.textContent || '{}');
    } catch (error) {
      console.error('Unable to parse Product Main configuration:', error);
      return;
    }

    const productMainSettings = productMainConfig.settings || {};
    
    const ProductGallery = {
      currentIndex: 0,
      thumbnailsOffset: 0,
      thumbnailWidth: 88,
      isDragging: false,
      startX: 0,
      startOffset: 0,
      dragThreshold: 10,
      hasMoved: false,
      isSwiping: false,
      swipeStartX: 0,
      swipeStartY: 0,
      swipeThreshold: 50,
      fullscreenCurrentIndex: 0,
      boundOnDrag: null,
      boundStopDrag: null,
      boundStartSwipe: null,
      boundOnSwipe: null,
      boundStopSwipe: null,
      resizeFrame: null,
      mediaData: Array.isArray(productMainConfig.media) ? productMainConfig.media : [],
      
      
      
      
      
      // Initialize main media
      initializeMainMedia() {
        const featuredMedia = productMainConfig.featuredMedia || null;
        if (!featuredMedia || this.mediaData.length === 0) return;
        
        const featuredIndex = this.mediaData.findIndex(media => media.id === featuredMedia.id);
        if (featuredIndex !== -1) {
          this.currentIndex = featuredIndex;
          
          if (featuredMedia.media_type === 'video') {
            const mainVideoContainer = document.getElementById('mainVideoContainer_new');
            const mainVideo = document.getElementById('mainVideo_new');
            const mainImage = document.getElementById('mainImage_new');
            
            if (mainVideoContainer && mainVideo && mainImage) {
              mainImage.style.display = 'none';
              mainVideoContainer.style.display = 'flex';
              mainVideo.src = featuredMedia.sources[0].url;
              mainVideo.load();
              
              mainVideo.addEventListener('play', () => mainVideoContainer.classList.add('video-playing_new'));
              mainVideo.addEventListener('pause', () => mainVideoContainer.classList.remove('video-playing_new'));
              mainVideo.addEventListener('ended', () => mainVideoContainer.classList.remove('video-playing_new'));
              mainVideo.addEventListener('loadeddata', () => {
                mainVideo.play().catch(() => {});
              });
            }
          }
          
          // Update active thumbnails
          document.querySelectorAll('.thumbnail-container_new').forEach((container, index) => {
            container.classList.remove('active_new');
            if (index === featuredIndex) container.classList.add('active_new');
          });
        }
      },
      
      // Setup event listeners
      setupEventListeners() {
        // Main image container click/swipe events
        const mainImageContainer = document.getElementById('mainImageContainer_new');
        const mainImage = document.getElementById('mainImage_new');
        
        if (mainImageContainer) {
          // Prevent native image drag
          if (mainImage) {
            mainImage.setAttribute('draggable', 'false');
            mainImage.addEventListener('dragstart', (e) => {
              e.preventDefault();
              return false;
            });
            mainImage.addEventListener('selectstart', (e) => {
              e.preventDefault();
              return false;
            });
          }
          
          // Prevent drag on container
          mainImageContainer.addEventListener('dragstart', (e) => {
            e.preventDefault();
            return false;
          });
          
          mainImageContainer.addEventListener('selectstart', (e) => {
            if (this.isSwiping) {
              e.preventDefault();
              return false;
            }
          });
          
          // Mouse events for desktop swipe
          let mouseDown = false;
          let mouseStartX = 0;
          let mouseStartY = 0;
          
          mainImageContainer.addEventListener('mousedown', (e) => {
            if (e.target.closest('.main-nav_new')) return;
            mouseDown = true;
            mouseStartX = e.clientX;
            mouseStartY = e.clientY;
            this.startSwipe(e);
            mainImageContainer.style.cursor = 'grabbing';
            
            const handleMouseMove = (moveEvent) => {
              if (!mouseDown) return;
              this.onSwipe(moveEvent);
            };
            
            const handleMouseUp = (upEvent) => {
              if (!mouseDown) return;
              mouseDown = false;
              mainImageContainer.style.cursor = 'grab';
              this.stopSwipe(upEvent);
              document.removeEventListener('mousemove', handleMouseMove);
              document.removeEventListener('mouseup', handleMouseUp);
            };
            
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
          });
          
          // Reset cursor if mouse leaves container
          mainImageContainer.addEventListener('mouseleave', () => {
            if (mouseDown) {
              mouseDown = false;
              mainImageContainer.style.cursor = 'grab';
            }
          });
          
          // Click event (only if not swiping)
          mainImageContainer.addEventListener('click', (e) => {
            if (e.target.closest('.main-nav_new')) return;
            // Only open fullscreen if it wasn't a swipe
            if (!this.isSwiping) {
              this.openFullscreen();
            }
          });
          
          // Touch events for mobile swipe
          mainImageContainer.addEventListener('touchstart', this.boundStartSwipe, { passive: true });
          mainImageContainer.addEventListener('touchmove', this.boundOnSwipe, { passive: false });
          mainImageContainer.addEventListener('touchend', this.boundStopSwipe, { passive: true });
        }
        
        // Thumbnails drag events
        const thumbnailsContainer = document.querySelector('.thumbnails_new');
        if (thumbnailsContainer) {
          thumbnailsContainer.addEventListener('mousedown', (e) => {
            // Only start drag if not clicking on a thumbnail
            if (!e.target.closest('.thumbnail-container_new')) {
              this.startDrag(e);
            }
          });
          thumbnailsContainer.addEventListener('touchstart', (e) => {
            // Only start drag if not touching a thumbnail
            if (!e.target.closest('.thumbnail-container_new')) {
              this.startDrag(e);
            }
          }, { passive: false });
          thumbnailsContainer.addEventListener('selectstart', (e) => {
            if (this.isDragging) e.preventDefault();
          });
        }
        
        // Fullscreen modal events
        const fullscreenModal = document.getElementById('fullscreenModal_new');
        if (fullscreenModal) {
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && fullscreenModal.classList.contains('active_new')) {
              this.closeFullscreen();
            }
          });
          
          fullscreenModal.addEventListener('click', (e) => {
            if (e.target === fullscreenModal) this.closeFullscreen();
          });
          
          const closeBtn = fullscreenModal.querySelector('.fullscreen-close_new');
          if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.closeFullscreen();
            });
          }
        }
        
        // Hide swipe indicator after 3 seconds
        setTimeout(() => {
          const swipeIndicator = document.getElementById('swipeIndicator_new');
          if (swipeIndicator) swipeIndicator.classList.add('hidden_new');
        }, 3000);
        
        // Window resize
        window.addEventListener('resize', () => {
          if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);

          this.resizeFrame = requestAnimationFrame(() => {
            this.thumbnailsOffset = 0;
            const container = document.querySelector('.thumbnails_new');
            if (container) container.style.transform = 'translateX(0px)';
            this.updateMainNavButtons();
            this.resizeFrame = null;
          });
        });
      },
      
      // Swipe functions
      startSwipe(e) {
        this.isSwiping = false;
        this.swipeStartX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
        this.swipeStartY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
      },
      
      onSwipe(e) {
        if (!this.isSwiping) {
          const currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
          const currentY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
          const deltaX = Math.abs(this.swipeStartX - currentX);
          const deltaY = Math.abs(this.swipeStartY - currentY);
          
          if (deltaX > 10 && deltaX > deltaY) {
            this.isSwiping = true;
            e.preventDefault();
          }
        }
        
        if (this.isSwiping) e.preventDefault();
      },
      
      stopSwipe(e) {
        if (this.isSwiping) {
          const currentX = e.type === 'mouseup' ? e.clientX : e.changedTouches[0].clientX;
          const deltaX = Math.abs(this.swipeStartX - currentX);
          
          if (deltaX > this.swipeThreshold) {
            if (this.swipeStartX > currentX) {
              this.changeImage(1);
            } else {
              this.changeImage(-1);
            }
          }
        }
        
        // Reset isSwiping after a small delay to allow click detection
        setTimeout(() => {
          this.isSwiping = false;
        }, 100);
      },
      
      // Drag functions
      startDrag(e) {
        // Check if click was on a thumbnail - if so, don't start drag
        const clickedThumbnail = e.target.closest('.thumbnail-container_new');
        if (clickedThumbnail) {
          // Allow the thumbnail click to work normally
          return;
        }
        
        this.isDragging = false;
        this.hasMoved = false;
        this.startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
        this.startOffset = this.thumbnailsOffset;
        
        if (e.type === 'mousedown') {
          document.addEventListener('mousemove', this.boundOnDrag);
          document.addEventListener('mouseup', this.boundStopDrag);
        } else {
          document.addEventListener('touchmove', this.boundOnDrag, { passive: false });
          document.addEventListener('touchend', this.boundStopDrag);
        }
      },
      
      
      stopDrag(e) {
        // If it was a click (not a drag), don't do anything
        if (!this.isDragging && !this.hasMoved) {
          this.cleanupDrag();
          return;
        }
        
        this.isDragging = false;
        this.cleanupDrag();
      },
      
      cleanupDrag() {
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        
        document.removeEventListener('mousemove', this.boundOnDrag);
        document.removeEventListener('mouseup', this.boundStopDrag);
        document.removeEventListener('touchmove', this.boundOnDrag);
        document.removeEventListener('touchend', this.boundStopDrag);
        
        setTimeout(() => { this.hasMoved = false; }, 50);
      },
      
      // Fullscreen functions
      openFullscreen() {
        const modal = document.getElementById('fullscreenModal_new');
        const fullscreenImage = document.getElementById('fullscreenImage_new');
        const fullscreenVideo = document.getElementById('fullscreenVideo_new');
        const mainImage = document.getElementById('mainImage_new');
        
        if (modal && fullscreenImage && fullscreenVideo) {
          // Garantir que o modal está no body
          if (modal.parentNode !== document.body) {
            document.body.appendChild(modal);
          }
          
          const currentMedia = this.mediaData[this.currentIndex];
          this.fullscreenCurrentIndex = this.currentIndex;
          
          if (currentMedia && currentMedia.media_type === 'video') {
            fullscreenImage.style.display = 'none';
            fullscreenVideo.style.display = 'block';
            fullscreenVideo.src = currentMedia.sources[0].url;
            fullscreenVideo.load();
            fullscreenVideo.addEventListener('loadeddata', () => {
              fullscreenVideo.play().catch(() => {});
            });
          } else {
            fullscreenVideo.style.display = 'none';
            fullscreenImage.style.display = 'block';
            if (currentMedia) {
              fullscreenImage.src = this.getMediaPreviewUrl(currentMedia, 1600);
              fullscreenImage.alt = currentMedia.alt || (mainImage ? mainImage.alt : '');
              fullscreenImage.decoding = 'async';
            }
          }
          
          this.updateFullscreenThumbnails();
          modal.style.display = 'flex';
          modal.classList.add('active_new');
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('modal-open_new');
        }
      },
      
      closeFullscreen() {
        const modal = document.getElementById('fullscreenModal_new');
        if (modal) {
          modal.classList.remove('active_new');
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('modal-open_new');
        }
      },
      
      
      
      
    };
    // ====================================================================
    // VARIANT MEDIA FILTERING BY IMAGE NAME / ALT
    // ====================================================================
    // Recommended Shopify-safe image-name or ALT formats:
    //   variant_5-50_LB_PDP_main
    //   variant_5-50_LB_variant_11-66_LB_PDP_main  (shared by two variant values)
    //   variant_id_1234567890_PDP_main           (exact variant ID)
    //   shared_PDP_size-guide                    (shown for every variant)
    // Spaces in variant values may be written as underscores.
    // Legacy [variant:...] ALT tags are still supported.

    Object.assign(ProductGallery, {
      visibleMediaIndexes: [],
      activeVariantId: null,
      variantMediaFilterEnabled: Boolean(productMainConfig.variantMediaFilterEnabled),
      modelProductMedia: {},
      variantFileKeyRecordsCache: null,
      mediaAltRulesCache: new Map(),
      configuredMediaAssociationsCache: null,

      readModelProductMedia() {
        const mediaJson = document.querySelector('script[data-model-product-media-0722]');
        if (!mediaJson) return;

        try {
          this.modelProductMedia = JSON.parse(mediaJson.textContent || '{}');
        } catch (error) {
          console.error('Unable to parse Product Main 0722 model media:', error);
          this.modelProductMedia = {};
        }
      },

      getMediaPreviewUrl(media, width) {
        const rawSource = media && media.preview_image && media.preview_image.src
          ? media.preview_image.src
          : media && media.src
            ? media.src
            : '';
        if (!rawSource) return '';

        const absoluteSource = String(rawSource).startsWith('//')
          ? `https:${rawSource}`
          : String(rawSource);
        const separator = absoluteSource.includes('?') ? '&' : '?';
        return `${absoluteSource}${separator}width=${width}`;
      },

      getResponsiveImageSrcset(media) {
        return [480, 720, 960, 1200, 1600]
          .map(width => `${this.getMediaPreviewUrl(media, width)} ${width}w`)
          .join(', ');
      },

      setMainImageMedia(imageElement, media) {
        if (!imageElement || !media) return;

        imageElement.src = this.getMediaPreviewUrl(media, 1200);
        imageElement.srcset = this.getResponsiveImageSrcset(media);
        imageElement.sizes = '(min-width: 1025px) 50vw, 100vw';
        imageElement.alt = media.alt || '';
        imageElement.decoding = 'async';
      },

      createVideoOverlay(className) {
        const overlay = document.createElement('div');
        overlay.className = className;
        overlay.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 5V19L19 12L8 5Z" fill="white"></path></svg>';
        return overlay;
      },

      rebuildModelThumbnails() {
        const thumbnails = document.querySelector('.thumbnails_new');
        const fullscreenThumbnails = document.getElementById('fullscreenThumbnailsContainer_new');

        if (thumbnails) thumbnails.replaceChildren();
        if (fullscreenThumbnails) fullscreenThumbnails.replaceChildren();

        this.mediaData.forEach((media, index) => {
          const isVideo = media && media.media_type === 'video';
          const previewUrl = this.getMediaPreviewUrl(media, 150);
          const videoUrl = isVideo && media.sources && media.sources[0]
            ? media.sources[0].url
            : '';

          if (thumbnails) {
            const thumbnailContainer = document.createElement('div');
            thumbnailContainer.className = 'thumbnail-container_new';
            thumbnailContainer.setAttribute('data-media-index', String(index));
            thumbnailContainer.setAttribute('data-media-id', String(media.id || ''));
            thumbnailContainer.setAttribute('role', 'button');
            thumbnailContainer.setAttribute('tabindex', '0');
            thumbnailContainer.setAttribute('aria-label', `View media ${index + 1}`);

            const thumbnailImage = document.createElement('img');
            thumbnailImage.className = isVideo
              ? 'thumbnail_new thumbnail-video'
              : 'thumbnail_new';
            thumbnailImage.src = previewUrl;
            thumbnailImage.alt = media.alt || '';
            thumbnailImage.width = 150;
            thumbnailImage.height = 113;
            thumbnailImage.loading = 'lazy';
            thumbnailImage.decoding = 'async';
            if (videoUrl) thumbnailImage.setAttribute('data-video-src', videoUrl);

            thumbnailContainer.appendChild(thumbnailImage);
            if (isVideo) {
              thumbnailContainer.appendChild(this.createVideoOverlay('video-thumbnail-overlay_new'));
            }
            thumbnailContainer.addEventListener('click', () => {
              this.changeMainMedia(index, thumbnailContainer, true);
            });
            thumbnailContainer.addEventListener('keydown', event => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              this.changeMainMedia(index, thumbnailContainer, true);
            });
            thumbnails.appendChild(thumbnailContainer);
          }

          if (fullscreenThumbnails) {
            const fullscreenContainer = document.createElement('div');
            fullscreenContainer.className = 'fullscreen-thumb-container_new';
            fullscreenContainer.setAttribute('data-media-index', String(index));
            fullscreenContainer.setAttribute('data-media-id', String(media.id || ''));
            fullscreenContainer.setAttribute('role', 'button');
            fullscreenContainer.setAttribute('tabindex', '0');
            fullscreenContainer.setAttribute('aria-label', `View fullscreen media ${index + 1}`);

            const fullscreenImage = document.createElement('img');
            fullscreenImage.className = isVideo
              ? 'fullscreen-thumb_new fullscreen-thumb-video'
              : 'fullscreen-thumb_new';
            fullscreenImage.src = previewUrl;
            fullscreenImage.alt = media.alt || '';
            fullscreenImage.width = 150;
            fullscreenImage.height = 113;
            fullscreenImage.loading = 'lazy';
            fullscreenImage.decoding = 'async';
            if (videoUrl) fullscreenImage.setAttribute('data-video-src', videoUrl);
            if (!isVideo) {
              fullscreenImage.setAttribute('data-fullsize', this.getMediaPreviewUrl(media, 1200));
            }

            fullscreenContainer.appendChild(fullscreenImage);
            if (isVideo) {
              fullscreenContainer.appendChild(this.createVideoOverlay('fullscreen-video-thumbnail-overlay_new'));
            }
            fullscreenContainer.addEventListener('click', () => {
              this.changeFullscreenMediaByIndex(index);
            });
            fullscreenContainer.addEventListener('keydown', event => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              this.changeFullscreenMediaByIndex(index);
            });
            fullscreenThumbnails.appendChild(fullscreenContainer);
          }
        });
      },

      setModelProductMedia(productId, variantId) {
        const productMedia = this.modelProductMedia[String(productId)];
        if (!productMedia || !Array.isArray(productMedia.media) || !productMedia.media.length) {
          return false;
        }

        const mainVideo = document.getElementById('mainVideo_new');
        const fullscreenVideo = document.getElementById('fullscreenVideo_new');
        [mainVideo, fullscreenVideo].forEach(video => {
          if (!video) return;
          video.pause();
          video.removeAttribute('src');
        });

        this.mediaData = productMedia.media;
        this.mediaAltRulesCache.clear();
        this.configuredMediaAssociationsCache = null;
        this.activeVariantId = variantId || null;
        this.currentIndex = 0;
        this.fullscreenCurrentIndex = 0;
        this.thumbnailsOffset = 0;
        this.visibleMediaIndexes = this.mediaData.map((_, index) => index);

        this.rebuildModelThumbnails();
        this.ensureMediaIndexAttributes();
        this.applyMediaVisibility();

        const thumbnails = document.querySelector('.thumbnails_new');
        if (thumbnails) thumbnails.style.transform = 'translateX(0px)';

        const featuredMediaId = String(productMedia.featuredMediaId || '');
        const featuredIndex = featuredMediaId
          ? this.mediaData.findIndex(media => String(media.id || '') === featuredMediaId)
          : -1;
        const preferredIndex = featuredIndex >= 0 ? featuredIndex : 0;
        this.currentIndex = preferredIndex;
        this.fullscreenCurrentIndex = preferredIndex;

        this.changeMainMedia(preferredIndex, this.getThumbnailByMediaIndex(preferredIndex), true);
        this.updateFullscreenThumbnails();
        this.updateMainNavButtons();

        if (sectionRoot) {
          sectionRoot.setAttribute('data-variant-media-filter-ready', 'true');
        }

        return true;
      },

      normalizeVariantKey(value) {
        return String(value == null ? '' : value)
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      },

      getVariantRawKeys(variant) {
        if (!variant) return [];

        const rawKeys = [
          variant.id,
          variant.title,
          ...(Array.isArray(variant.options) ? variant.options : []),
          variant.option1,
          variant.option2,
          variant.option3
        ];

        return [...new Set(
          rawKeys
            .map(value => String(value == null ? '' : value).trim())
            .filter(value => value && value.toLowerCase() !== 'default title')
        )];
      },

      getVariantKeys(variant) {
        return [...new Set(
          this.getVariantRawKeys(variant)
            .map(value => this.normalizeVariantKey(value))
            .filter(Boolean)
        )];
      },

      getAllVariantKeys() {
        if (typeof ProductVariants === 'undefined' || !Array.isArray(ProductVariants.variants)) {
          return [];
        }

        return [...new Set(
          ProductVariants.variants.flatMap(variant => this.getVariantKeys(variant))
        )];
      },

      getFileKeyCandidates(value) {
        const source = String(value == null ? '' : value)
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          // Shopify/admin values may use an en dash or em dash while file names use "-".
          .replace(/[‐‑‒–—―−]/g, '-')
          .replace(/&/g, ' and ')
          .replace(/[’']/g, '')
          .replace(/\s*-\s*/g, '-')
          .replace(/\s+/g, ' ')
          .trim();

        if (!source) return [];

        const sourceForms = new Set([source]);
        const unitAliases = [
          ['lb', 'lbs', 'pound', 'pounds'],
          ['kg', 'kgs', 'kilogram', 'kilograms'],
          ['oz', 'ounce', 'ounces'],
          ['in', 'inch', 'inches'],
          ['cm'],
          ['mm']
        ];

        // Generate singular/plural unit aliases. For example, the option
        // "11 – 66 lbs" can match file names containing 11-66_LB or 11-66_LBS.
        unitAliases.forEach(aliasGroup => {
          const aliasPattern = new RegExp(`\\b(?:${aliasGroup.join('|')})\\b`, 'i');
          if (!aliasPattern.test(source)) return;

          aliasGroup.forEach(alias => {
            sourceForms.add(source.replace(aliasPattern, alias));
          });
        });

        const candidates = [];
        const seen = new Set();
        const addCandidate = (fileKey, priority) => {
          const cleaned = String(fileKey || '')
            .replace(/^_+|_+$/g, '')
            .replace(/_+/g, '_');

          if (!cleaned || seen.has(cleaned)) return;
          seen.add(cleaned);
          candidates.push({ fileKey: cleaned, priority });
        };

        sourceForms.forEach(form => {
          const rangePreservingKey = form
            .replace(/[^a-z0-9-]+/g, '_')
            .replace(/^_+|_+$/g, '')
            .replace(/_+/g, '_');

          const underscoreOnlyKey = form
            .replace(/[^a-z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '')
            .replace(/_+/g, '_');

          addCandidate(rangePreservingKey, 4);
          addCandidate(underscoreOnlyKey, 3);

          // Accept unit-first file names too: 66_LB ↔ LB_66 and
          // 11-66_LB ↔ LB_11-66. The complete range is retained.
          [rangePreservingKey, underscoreOnlyKey].forEach(key => {
            const unitAtEnd = key.match(/^(.+?)_(lb|lbs|kg|kgs|oz|in|inch|inches|cm|mm)$/i);
            if (unitAtEnd) {
              addCandidate(`${unitAtEnd[2]}_${unitAtEnd[1]}`, 2);
            }

            const unitAtStart = key.match(/^(lb|lbs|kg|kgs|oz|in|inch|inches|cm|mm)_(.+)$/i);
            if (unitAtStart) {
              addCandidate(`${unitAtStart[2]}_${unitAtStart[1]}`, 2);
            }
          });
        });

        return candidates.sort((a, b) =>
          b.fileKey.length - a.fileKey.length || b.priority - a.priority
        );
      },

      getVariantFileKeyRecords() {
        if (this.variantFileKeyRecordsCache) {
          return this.variantFileKeyRecordsCache;
        }

        if (typeof ProductVariants === 'undefined' || !Array.isArray(ProductVariants.variants)) {
          return [];
        }

        const records = [];
        const seen = new Set();

        ProductVariants.variants.forEach(variant => {
          this.getVariantRawKeys(variant).forEach(rawValue => {
            const normalized = this.normalizeVariantKey(rawValue);
            if (!normalized) return;

            this.getFileKeyCandidates(rawValue).forEach(candidate => {
              const fileKey = candidate.fileKey;
              const recordKey = `${normalized}::${fileKey}`;
              if (seen.has(recordKey)) return;
              seen.add(recordKey);
              records.push({ normalized, fileKey, priority: candidate.priority });
            });
          });
        });

        // Longest value first prevents "66" from winning over "66_LB".
        this.variantFileKeyRecordsCache = records.sort((a, b) =>
          b.fileKey.length - a.fileKey.length || b.priority - a.priority
        );

        return this.variantFileKeyRecordsCache;
      },

      getMediaAssociationTexts(media) {
        const texts = [];
        const addText = value => {
          const text = String(value == null ? '' : value).trim();
          if (text) texts.push(text);
        };
        const addUrlFileName = value => {
          if (!value) return;

          let cleanValue = String(value).split('?')[0].split('#')[0];
          try {
            cleanValue = decodeURIComponent(cleanValue);
          } catch (error) {}

          const fileName = cleanValue
            .split('/')
            .pop()
            .replace(/\.[a-z0-9]+$/i, '')
            .trim();

          addText(fileName);
        };

        addText(media && media.alt);
        addUrlFileName(media && media.src);
        addUrlFileName(media && media.preview_image && media.preview_image.src);

        if (media && Array.isArray(media.sources)) {
          media.sources.forEach(source => addUrlFileName(source && source.url));
        }

        return [...new Set(texts)];
      },

      extractUnderscoreAssociationRules(text) {
        const source = String(text == null ? '' : text)
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\.[a-z0-9]+$/i, '')
          .replace(/-variant-/g, '_variant_')
          .replace(/-var-/g, '_var_');

        const variantTokens = [];
        const variantIds = [];
        let isShared = false;
        let hasExplicitRule = false;

        if (!source) {
          return { variantTokens, variantIds, isShared, hasExplicitRule };
        }

        // Examples:
        // variant_5-50_LB_PDP_main
        // variant_5-50_LB_variant_LB_66_PDP_main
        // variant_id_1234567890_PDP_main
        // shared_PDP_size-guide
        const markerPattern = /(?:^|_)(?:variant|var)_/i;
        if (markerPattern.test(source)) {
          hasExplicitRule = true;
        }

        if (/(?:^|_)(?:shared|all)(?:_|$)/i.test(source) ||
            /(?:^|_)(?:variant|var)_(?:shared|all)(?:_|$)/i.test(source)) {
          hasExplicitRule = true;
          isShared = true;
        }

        let idMatch;
        const idRegex = /(?:^|_)(?:variant|var)_id_(\d+)(?=_|$)/gi;
        while ((idMatch = idRegex.exec(source)) !== null) {
          variantIds.push(idMatch[1]);
        }

        const segments = source.split(/(?:^|_)(?:variant|var)_/i).slice(1);
        const records = this.getVariantFileKeyRecords();

        segments.forEach(segment => {
          if (!segment || /^(?:id_\d+|all|shared)(?:_|$)/i.test(segment)) return;

          let bestMatch = null;

          for (const record of records) {
            const key = record.fileKey;
            if (segment === key || segment.startsWith(`${key}_`)) {
              bestMatch = record;
              break;
            }
          }

          if (bestMatch) {
            variantTokens.push(bestMatch.normalized);
          }
        });

        return {
          variantTokens: [...new Set(variantTokens)],
          variantIds: [...new Set(variantIds)],
          isShared,
          hasExplicitRule
        };
      },

      getMediaAltRules(media) {
        const cacheKey = String(media && media.id ? media.id : '');
        if (cacheKey && this.mediaAltRulesCache.has(cacheKey)) {
          return this.mediaAltRulesCache.get(cacheKey);
        }

        const rawAlt = String(media && media.alt ? media.alt : '').trim();
        const associationTexts = this.getMediaAssociationTexts(media);
        const variantTokens = [];
        const variantIds = [];
        let isShared = false;
        let hasExplicitRule = false;
        let match;

        associationTexts.forEach(associationText => {
          // Legacy format: [variant:Black], [variant=88 LB], [var:Pair]
          const bracketVariantRegex = /\[(?:variant|var)\s*[:=]\s*([^\]]+)\]/gi;
          while ((match = bracketVariantRegex.exec(associationText)) !== null) {
            hasExplicitRule = true;
            String(match[1])
              .split(/[|,;/]+/)
              .map(value => this.normalizeVariantKey(value))
              .filter(Boolean)
              .forEach(value => {
                if (value === 'all' || value === 'shared') {
                  isShared = true;
                } else {
                  variantTokens.push(value);
                }
              });
          }

          // Legacy format: [variant-id:1234567890]
          const variantIdRegex = /\[variant-id\s*[:=]\s*([^\]]+)\]/gi;
          while ((match = variantIdRegex.exec(associationText)) !== null) {
            hasExplicitRule = true;
            String(match[1])
              .split(/[|,;/]+/)
              .map(value => String(value).trim())
              .filter(Boolean)
              .forEach(value => variantIds.push(value));
          }

          if (/\[(?:shared|all)\]/i.test(associationText)) {
            hasExplicitRule = true;
            isShared = true;
          }

          // Legacy format: variant:Black | descriptive text
          const plainVariantMatch = associationText.match(/^(?:variant|var)\s*[:=]\s*([^|;]+)/i);
          if (plainVariantMatch) {
            hasExplicitRule = true;
            const value = this.normalizeVariantKey(plainVariantMatch[1]);
            if (value === 'all' || value === 'shared') {
              isShared = true;
            } else if (value) {
              variantTokens.push(value);
            }
          }

          // New Shopify-safe file-name/ALT format using underscores.
          const underscoreRules = this.extractUnderscoreAssociationRules(associationText);
          if (underscoreRules.hasExplicitRule) hasExplicitRule = true;
          if (underscoreRules.isShared) isShared = true;
          underscoreRules.variantTokens.forEach(value => variantTokens.push(value));
          underscoreRules.variantIds.forEach(value => variantIds.push(value));
        });

        const result = {
          rawAlt,
          exactAlt: this.normalizeVariantKey(rawAlt),
          variantTokens: [...new Set(variantTokens)],
          variantIds: [...new Set(variantIds)],
          isShared,
          hasExplicitRule
        };

        if (cacheKey) {
          this.mediaAltRulesCache.set(cacheKey, result);
        }

        return result;
      },

      hasConfiguredMediaAssociations() {
        if (this.configuredMediaAssociationsCache !== null) {
          return this.configuredMediaAssociationsCache;
        }

        const allVariantKeys = this.getAllVariantKeys();
        this.configuredMediaAssociationsCache = this.mediaData.some(media => {
          const rules = this.getMediaAltRules(media);
          if (rules.hasExplicitRule) return true;
          return !!rules.exactAlt && allVariantKeys.includes(rules.exactAlt);
        });

        return this.configuredMediaAssociationsCache;
      },

      mediaBelongsToVariant(media, variant, filteringEnabled) {
        if (!filteringEnabled) return true;

        const rules = this.getMediaAltRules(media);
        const variantKeys = this.getVariantKeys(variant);
        const variantId = String(variant && variant.id ? variant.id : '');

        if (rules.isShared) return true;
        if (rules.variantIds.includes(variantId)) return true;
        if (rules.variantTokens.some(token => variantKeys.includes(token))) return true;

        // Backward-compatible simple mode: ALT exactly equals a variant title/value.
        if (!rules.hasExplicitRule && rules.exactAlt && variantKeys.includes(rules.exactAlt)) {
          return true;
        }

        return false;
      },

      getVariantFeaturedMediaIndex(variant) {
        if (!variant || !variant.featured_image) return -1;

        const variantImageId = variant.featured_image.id;
        const variantImageSrc = String(variant.featured_image.src || '').split('?')[0];

        return this.mediaData.findIndex(media => {
          if (!media) return false;

          if (media.media_type === 'image' && media.id === variantImageId) {
            return true;
          }

          const mediaSrc = String(media.src || '').split('?')[0];
          if (mediaSrc && variantImageSrc && (
            mediaSrc === variantImageSrc ||
            mediaSrc.includes(variantImageSrc) ||
            variantImageSrc.includes(mediaSrc)
          )) {
            return true;
          }

          const previewImage = media.preview_image;
          if (previewImage && previewImage.id === variantImageId) {
            return true;
          }

          const previewSrc = String(previewImage && previewImage.src ? previewImage.src : '').split('?')[0];
          return !!previewSrc && !!variantImageSrc && (
            previewSrc === variantImageSrc ||
            previewSrc.includes(variantImageSrc) ||
            variantImageSrc.includes(previewSrc)
          );
        });
      },

      ensureMediaIndexAttributes() {
        document.querySelectorAll('.thumbnail-container_new').forEach((element, index) => {
          element.setAttribute('data-media-index', String(index));
        });

        document.querySelectorAll('.fullscreen-thumb-container_new').forEach((element, index) => {
          element.setAttribute('data-media-index', String(index));
        });
      },

      getThumbnailByMediaIndex(mediaIndex) {
        return document.querySelector(`.thumbnail-container_new[data-media-index="${mediaIndex}"]`) ||
          document.querySelectorAll('.thumbnail-container_new')[mediaIndex] ||
          null;
      },

      getFullscreenThumbnailByMediaIndex(mediaIndex) {
        return document.querySelector(`.fullscreen-thumb-container_new[data-media-index="${mediaIndex}"]`) ||
          document.querySelectorAll('.fullscreen-thumb-container_new')[mediaIndex] ||
          null;
      },

      applyMediaVisibility() {
        const visibleSet = new Set(this.visibleMediaIndexes);

        document.querySelectorAll('.thumbnail-container_new').forEach((element, index) => {
          const mediaIndex = Number(element.getAttribute('data-media-index') ?? index);
          const isVisible = visibleSet.has(mediaIndex);
          element.style.display = isVisible ? '' : 'none';
          element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        });

        document.querySelectorAll('.fullscreen-thumb-container_new').forEach((element, index) => {
          const mediaIndex = Number(element.getAttribute('data-media-index') ?? index);
          const isVisible = visibleSet.has(mediaIndex);
          element.style.display = isVisible ? '' : 'none';
          element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        });
      },

      filterMediaForVariant(variant) {
        if (!variant || !this.mediaData.length) return;

        this.ensureMediaIndexAttributes();

        // The Shopify section setting is the master switch. When disabled,
        // all product media remain visible and the gallery keeps its normal behavior.
        const filteringEnabled = this.variantMediaFilterEnabled && this.hasConfiguredMediaAssociations();
        const featuredIndex = this.getVariantFeaturedMediaIndex(variant);
        let visibleIndexes = this.mediaData
          .map((media, index) => this.mediaBelongsToVariant(media, variant, filteringEnabled) ? index : -1)
          .filter(index => index !== -1);

        // Shopify's assigned variant image is always considered related.
        if (featuredIndex !== -1 && !visibleIndexes.includes(featuredIndex)) {
          visibleIndexes.push(featuredIndex);
        }

        visibleIndexes.sort((a, b) => a - b);

        // Never leave the gallery blank because of an ALT typo.
        if (!visibleIndexes.length) {
          visibleIndexes = featuredIndex !== -1
            ? [featuredIndex]
            : this.mediaData.map((_, index) => index);
        }

        this.visibleMediaIndexes = visibleIndexes;
        this.activeVariantId = variant.id;
        this.thumbnailsOffset = 0;

        const thumbnailsContainer = document.querySelector('.thumbnails_new');
        if (thumbnailsContainer) {
          thumbnailsContainer.style.transform = 'translateX(0px)';
        }

        this.applyMediaVisibility();

        // Reveal the thumbnail rail only after the correct variant media are applied.
        if (sectionRoot) {
          sectionRoot.setAttribute('data-variant-media-filter-ready', 'true');
        }

        const preferredIndex = featuredIndex !== -1 && visibleIndexes.includes(featuredIndex)
          ? featuredIndex
          : visibleIndexes[0];
        const preferredThumb = this.getThumbnailByMediaIndex(preferredIndex);

        this.changeMainMedia(preferredIndex, preferredThumb, true);
        this.scrollToActiveThumbnail();
        this.updateFullscreenThumbnails();
      },

      changeMainMedia(mediaIndex, clickedThumb, force = false) {
        if (!force && (this.isDragging || this.hasMoved)) return;
        if (!force && this.visibleMediaIndexes.length && !this.visibleMediaIndexes.includes(mediaIndex)) return;

        const media = this.mediaData[mediaIndex];
        if (!media) return;

        const mainImage = document.getElementById('mainImage_new');
        const mainVideo = document.getElementById('mainVideo_new');
        const mainVideoContainer = document.getElementById('mainVideoContainer_new');

        this.currentIndex = mediaIndex;

        document.querySelectorAll('.thumbnail-container_new').forEach(container => {
          container.classList.remove('active_new');
        });

        const targetThumb = clickedThumb || this.getThumbnailByMediaIndex(mediaIndex);
        if (targetThumb) targetThumb.classList.add('active_new');

        if (media.media_type === 'video') {
          if (mainImage) mainImage.style.display = 'none';
          if (mainVideoContainer) mainVideoContainer.style.display = 'flex';

          if (mainVideo && media.sources && media.sources[0]) {
            mainVideo.src = media.sources[0].url;
            mainVideo.load();
            mainVideo.onplay = () => mainVideoContainer && mainVideoContainer.classList.add('video-playing_new');
            mainVideo.onpause = () => mainVideoContainer && mainVideoContainer.classList.remove('video-playing_new');
            mainVideo.onended = () => mainVideoContainer && mainVideoContainer.classList.remove('video-playing_new');
            mainVideo.onloadeddata = () => {
              mainVideo.play().catch(() => {});
            };
          }
        } else {
          if (mainVideo) {
            mainVideo.pause();
            mainVideo.removeAttribute('src');
          }
          if (mainVideoContainer) mainVideoContainer.style.display = 'none';

          if (mainImage) {
            mainImage.style.display = 'block';
            this.setMainImageMedia(mainImage, media);
          }
        }

        this.updateMainNavButtons();
      },

      changeImage(direction) {
        const visibleIndexes = this.visibleMediaIndexes.length
          ? this.visibleMediaIndexes
          : this.mediaData.map((_, index) => index);

        if (!visibleIndexes.length) return;

        let visiblePosition = visibleIndexes.indexOf(this.currentIndex);
        if (visiblePosition === -1) visiblePosition = 0;
        visiblePosition = (visiblePosition + direction + visibleIndexes.length) % visibleIndexes.length;

        const nextMediaIndex = visibleIndexes[visiblePosition];
        this.changeMainMedia(nextMediaIndex, this.getThumbnailByMediaIndex(nextMediaIndex), true);
        this.scrollToActiveThumbnail();
      },

      updateMainNavButtons() {
        const prevBtn = document.querySelector('.main-prev_new');
        const nextBtn = document.querySelector('.main-next_new');
        const visibleCount = this.visibleMediaIndexes.length || this.mediaData.length;

        if (prevBtn) prevBtn.disabled = visibleCount <= 1;
        if (nextBtn) nextBtn.disabled = visibleCount <= 1;
      },

      scrollToActiveThumbnail() {
        const thumbnailsScroll = document.querySelector('.thumbnails-scroll_new');
        const thumbnailsContainer = document.querySelector('.thumbnails_new');
        const visibleIndexes = this.visibleMediaIndexes.length
          ? this.visibleMediaIndexes
          : this.mediaData.map((_, index) => index);

        if (!thumbnailsScroll || !thumbnailsContainer || visibleIndexes.length <= 5) return;

        const visiblePosition = Math.max(0, visibleIndexes.indexOf(this.currentIndex));
        const scrollWidth = thumbnailsScroll.offsetWidth;
        const totalWidth = visibleIndexes.length * this.thumbnailWidth;
        let idealOffset = visiblePosition * this.thumbnailWidth - (scrollWidth / 2) + (this.thumbnailWidth / 2);
        idealOffset = Math.max(0, Math.min(Math.max(0, totalWidth - scrollWidth), idealOffset));

        this.thumbnailsOffset = idealOffset;
        thumbnailsContainer.style.transform = `translateX(-${this.thumbnailsOffset}px)`;
      },

      onDrag(e) {
        const currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
        const deltaX = Math.abs(this.startX - currentX);

        if (!this.hasMoved && deltaX > this.dragThreshold) {
          this.isDragging = true;
          this.hasMoved = true;
          document.body.style.cursor = 'grabbing';
          document.body.style.userSelect = 'none';
        }

        if (!this.isDragging) return;

        e.preventDefault();
        const newOffset = this.startOffset + (this.startX - currentX);
        const thumbnailsScroll = document.querySelector('.thumbnails-scroll_new');
        const visibleCount = this.visibleMediaIndexes.length || this.mediaData.length;

        if (thumbnailsScroll && visibleCount > 5) {
          const scrollWidth = thumbnailsScroll.offsetWidth;
          const totalWidth = visibleCount * this.thumbnailWidth;
          const maxOffset = Math.max(0, totalWidth - scrollWidth);

          this.thumbnailsOffset = Math.max(0, Math.min(maxOffset, newOffset));

          const thumbnailsContainer = document.querySelector('.thumbnails_new');
          if (thumbnailsContainer) {
            thumbnailsContainer.style.transform = `translateX(-${this.thumbnailsOffset}px)`;
          }
        }
      },

      changeFullscreenImage(direction) {
        const visibleIndexes = this.visibleMediaIndexes.length
          ? this.visibleMediaIndexes
          : this.mediaData.map((_, index) => index);

        if (!visibleIndexes.length) return;

        let visiblePosition = visibleIndexes.indexOf(this.fullscreenCurrentIndex);
        if (visiblePosition === -1) visiblePosition = 0;
        visiblePosition = (visiblePosition + direction + visibleIndexes.length) % visibleIndexes.length;
        this.fullscreenCurrentIndex = visibleIndexes[visiblePosition];

        const currentMedia = this.mediaData[this.fullscreenCurrentIndex];
        const fullscreenImage = document.getElementById('fullscreenImage_new');
        const fullscreenVideo = document.getElementById('fullscreenVideo_new');

        if (!currentMedia || !fullscreenImage || !fullscreenVideo) return;

        if (currentMedia.media_type === 'video') {
          fullscreenImage.style.display = 'none';
          fullscreenVideo.style.display = 'block';
          if (currentMedia.sources && currentMedia.sources[0]) {
            fullscreenVideo.src = currentMedia.sources[0].url;
            fullscreenVideo.load();
            fullscreenVideo.onloadeddata = () => {
              fullscreenVideo.play().catch(() => {});
            };
          }
        } else {
          fullscreenVideo.pause();
          fullscreenVideo.style.display = 'none';
          fullscreenImage.style.display = 'block';
          fullscreenImage.src = this.getMediaPreviewUrl(currentMedia, 1600);
          fullscreenImage.alt = currentMedia.alt || '';
          fullscreenImage.decoding = 'async';
        }

        this.updateFullscreenThumbnails();
      },

      changeFullscreenMediaByIndex(index) {
        const visibleIndexes = this.visibleMediaIndexes.length
          ? this.visibleMediaIndexes
          : this.mediaData.map((_, mediaIndex) => mediaIndex);

        if (!visibleIndexes.includes(index)) return;
        this.fullscreenCurrentIndex = index;
        this.changeFullscreenImage(0);
      },

      updateFullscreenThumbnails() {
        const thumbnailsContainer = document.getElementById('fullscreenThumbnailsContainer_new');

        document.querySelectorAll('.fullscreen-thumb-container_new').forEach((container, index) => {
          const mediaIndex = Number(container.getAttribute('data-media-index') ?? index);
          const isActive = mediaIndex === this.fullscreenCurrentIndex;
          container.classList.toggle('active_new', isActive);

          if (isActive && thumbnailsContainer && container.style.display !== 'none') {
            const containerRect = container.getBoundingClientRect();
            const scrollContainerRect = thumbnailsContainer.getBoundingClientRect();
            const scrollLeft = thumbnailsContainer.scrollLeft;
            const containerLeft = containerRect.left - scrollContainerRect.left + scrollLeft;
            const targetScroll = containerLeft - (scrollContainerRect.width / 2) + (containerRect.width / 2);

            thumbnailsContainer.scrollTo({
              left: targetScroll,
              behavior: 'smooth'
            });
          }
        });
      },

      init() {
        const modal = document.getElementById('fullscreenModal_new');

        this.boundOnDrag ||= this.onDrag.bind(this);
        this.boundStopDrag ||= this.stopDrag.bind(this);
        this.boundStartSwipe ||= this.startSwipe.bind(this);
        this.boundOnSwipe ||= this.onSwipe.bind(this);
        this.boundStopSwipe ||= this.stopSwipe.bind(this);

        this.readModelProductMedia();
        this.ensureMediaIndexAttributes();
        this.visibleMediaIndexes = this.mediaData.map((_, index) => index);

        if (modal && modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }

        this.initializeMainMedia();
        this.applyMediaVisibility();
        this.updateMainNavButtons();
        this.setupEventListeners();
      }
    });

    
    // Make gallery functions global for onclick handlers
    window.changeMainMedia = (index, thumb) => ProductGallery.changeMainMedia(index, thumb);
    window.changeImage = (direction) => ProductGallery.changeImage(direction);
    window.openFullscreen = () => ProductGallery.openFullscreen();
    window.closeFullscreen = () => ProductGallery.closeFullscreen();
    window.changeFullscreenImage = (direction) => ProductGallery.changeFullscreenImage(direction);
    window.changeFullscreenMediaByIndex = (index) => ProductGallery.changeFullscreenMediaByIndex(index);
    
    // ====================================================================
    // VARIANT & CART FUNCTIONS
    // ====================================================================

    const sectionRoot = document.querySelector(`[data-section-id="${productMainConfig.sectionId}"]`);
    const querySection = (selector) => sectionRoot ? sectionRoot.querySelector(selector) : document.querySelector(selector);
    const getProductForm = () => document.getElementById(`product-form-${productMainConfig.sectionId}`) || querySection('.product-form_new');
    const getVariantSelector = () => querySection('#variant-selector_new');
    const getMobileVariantSelector = () => querySection('#variant-selector-mobile_new');
    const getQuantityInput = () => querySection('#quantity_new');
    const getAddToCartButton = () => querySection('button[name="add"].add-to-cart-btn_new:not(.waitlist-btn_new)');
    const getBuyItNowButton = () => querySection('.buy-it-now-btn_new');
    
    const ProductVariants = {
      variants: Array.isArray(productMainConfig.variants) ? productMainConfig.variants : [],
      currentSelector: null,

      /**
      * Update the browser URL to match the selected variant.
      * Example:
      * /products/adjustable-dumbbell?variant=123456789
      *
      * replaceState changes the URL without refreshing the page
      * and without adding a new browser history entry each time.
      */
      updateVariantUrl(variant) {
        if (!variant || !variant.id) return;

        const url = new URL(window.location.href);

        // Preserve existing parameters such as UTM parameters,
        // while updating only the variant parameter.
        url.searchParams.set('variant', String(variant.id));

        window.history.replaceState(
          {
            variantId: String(variant.id)
          },
          '',
          url.toString()
        );
      },
      
      updateVariant(sourceSelector = null) {
        let selectedVariant = null;
        // Check both desktop and mobile selectors
        const variantSelectorDesktop = getVariantSelector();
        const variantSelectorMobile = getMobileVariantSelector();
        
        // Determine which selector to use
        let variantSelector = sourceSelector;
        if (!variantSelector) {
          // Check which one is visible or recently interacted with
          if (variantSelectorMobile && window.getComputedStyle(variantSelectorMobile).display !== 'none') {
            variantSelector = variantSelectorMobile;
          } else if (variantSelectorDesktop) {
            variantSelector = variantSelectorDesktop;
          }
        }
        
        if (variantSelector) {
          const selectedVariantId = parseInt(variantSelector.value);
          selectedVariant = this.variants.find(v => v.id === selectedVariantId);
          
          // Sync both selectors
          if (variantSelectorDesktop && variantSelectorMobile) {
            variantSelectorDesktop.value = selectedVariantId;
            variantSelectorMobile.value = selectedVariantId;
          }
        }
        
        if (selectedVariant) {
          this.updatePrice(selectedVariant);
          ProductGallery.filterMediaForVariant(selectedVariant);
          this.updateProductForm(selectedVariant);
          this.updateDynamicCheckout(selectedVariant);
          this.updateButtonsForVariant(selectedVariant);

          // Update browser URL without refreshing the product page.
          this.updateVariantUrl(selectedVariant);
        }
      },
      
      updateButtonsForVariant(variant) {
        // Check if waitlist should be shown for this variant
        const waitlistVariants = String(productMainSettings.waitlistVariantIds || '');
        const showWaitlistGlobal = Boolean(productMainSettings.showWaitlistButton);
        
        let shouldShowWaitlist = false;
        
        if (showWaitlistGlobal) {
          if (!waitlistVariants || waitlistVariants.trim() === '') {
            // No variants specified, show for all variants
            shouldShowWaitlist = true;
          } else {
            // Check if current variant ID or name (title) is in the list
            const variantList = waitlistVariants.split(',').map(item => item.trim().toLowerCase());
            const variantIdString = variant.id.toString();
            const variantTitle = variant.title ? variant.title.trim().toLowerCase() : '';
            
            // Check by ID (case-sensitive) or by name (case-insensitive)
            const variantIdInList = variantList.some(item => item === variantIdString);
            const variantNameInList = variantList.some(item => item === variantTitle);
            
            shouldShowWaitlist = variantIdInList || variantNameInList;
            
          }
        }
        
        // Get buttons - use more specific selectors
        const addToCartBtn = getAddToCartButton();
        const waitlistBtn = querySection('.waitlist-btn_new.klaviyo_waitlist_trigger');
        const buyItNowBtn = getBuyItNowButton();
        
        
        // Check if variant is available
        const isVariantAvailable = variant.available || false;
        
        if (shouldShowWaitlist) {
          // Show waitlist button, hide add to cart and buy it now (even if variant is sold out)
          if (addToCartBtn) {
            addToCartBtn.style.display = 'none';
          }
          if (waitlistBtn) {
            waitlistBtn.style.display = '';
            waitlistBtn.setAttribute('data-variant-id', variant.id);
            // Update Klaviyo form ID if needed
            const formId = waitlistBtn.getAttribute('data-klaviyo-form-id');
            if (!formId || formId.trim() === '') {
              console.warn('Klaviyo Form ID is missing from waitlist button');
            }
          } else {
            console.warn('Waitlist button not found in DOM');
          }
          if (buyItNowBtn) {
            buyItNowBtn.style.display = 'none';
          }
        } else {
          // Show add to cart and buy it now only if variant is available, hide waitlist
          if (addToCartBtn) {
            // Only show add to cart if variant is available
            addToCartBtn.style.display = isVariantAvailable ? '' : 'none';
            addToCartBtn.setAttribute('data-variant-id', variant.id);
          }
          if (waitlistBtn) {
            waitlistBtn.style.display = 'none';
          }
          // Only show buy it now if variant is available
          if (buyItNowBtn && productMainSettings.showBuyItNow && isVariantAvailable) {
            buyItNowBtn.style.display = '';
          } else           if (buyItNowBtn) {
            buyItNowBtn.style.display = 'none';
          }
        }

        const stickyAtc = document.querySelector('#sticky-add-to-cart .sticky-add-to-cart-button');
        if (stickyAtc) {
          const inStockLabel = stickyAtc.getAttribute('data-in-stock-label') || 'Add to Cart';
          if (isVariantAvailable) {
            stickyAtc.disabled = false;
            stickyAtc.textContent = inStockLabel;
          } else {
            stickyAtc.disabled = true;
            stickyAtc.textContent = 'Sold Out';
          }
        }
      },
      
      updateProductForm(variant) {
        // Update hidden input in the main product form
        const productForm = getProductForm();
        if (productForm && variant) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variant.id;
          }
          
          // Update hidden variant input with section ID
          const variantInputWithId = document.getElementById(`product-variant-id-${productMainConfig.sectionId}`);
          if (variantInputWithId) {
            variantInputWithId.value = variant.id;
          }
          
          // Update select[name="id"] if it exists
          const variantSelect = productForm.querySelector('select[name="id"]');
          if (variantSelect) {
            variantSelect.value = variant.id;
          }
          
          // Update variant selectors if they exist (both desktop and mobile)
          const variantSelectorDesktop = getVariantSelector();
          const variantSelectorMobile = getMobileVariantSelector();
          if (variantSelectorDesktop) {
            variantSelectorDesktop.value = variant.id;
          }
          if (variantSelectorMobile) {
            variantSelectorMobile.value = variant.id;
          }
          
          // Update shopify-payment-terms component if it exists
          const paymentTerms = productForm.querySelector('shopify-payment-terms');
          if (paymentTerms) {
            paymentTerms.setAttribute('variant-id', variant.id);
          }
        }
      },
      
      updateDynamicCheckout(variant) {
        // Dynamic checkout buttons are automatically updated by Shopify
        // But we can trigger a refresh if needed
        const dynamicCheckout = document.querySelector('[id^="dynamic-checkout"]');
        if (dynamicCheckout && variant) {
          // Shopify handles this automatically, but we ensure the form is updated
          const productForm = getProductForm();
          if (productForm) {
            // Trigger form change event to update Shopify's dynamic checkout
            const event = new Event('change', { bubbles: true });
            const variantInput = productForm.querySelector('input[name="id"]');
            if (variantInput) {
              variantInput.dispatchEvent(event);
            }
          }
        }
      },
      
      updatePrice(variant) {
        if (!variant) return;
        
        // Helper function to format money with fallback
        const formatMoney = (cents) => {
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            const moneyFormat = window.theme?.moneyFormat || window.Shopify?.money_format || ('$' + '{' + '{amount}' + '}');
            return window.Shopify.formatMoney(cents, moneyFormat);
          }
          // Fallback: format as USD currency
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format((cents || 0) / 100);
        };
        
        // Update main price
        const priceElements = document.querySelectorAll('.product-price_new');
        priceElements.forEach(el => {
          if (el) {
            el.textContent = formatMoney(variant.price);
          }
        });
        
        // Update compare at price (original price)
        const comparePriceElements = document.querySelectorAll('.product-price-original_new');
        comparePriceElements.forEach(el => {
          if (el) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              el.textContent = formatMoney(variant.compare_at_price);
              el.style.display = 'block';
            } else {
              el.style.display = 'none';
            }
          }
        });

        const saveBadgeElements = document.querySelectorAll('.product-save-badge-0722');
        saveBadgeElements.forEach(el => {
          if (!el) return;
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const discountPercent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            el.textContent = String(productMainSettings.discountBadgePrefix || 'Save') + ' ' + discountPercent + '%';
            el.style.display = 'inline-flex';
          } else {
            el.style.display = 'none';
          }
        });

        if (typeof window.updateBuybox0722Variant === 'function') {
          window.updateBuybox0722Variant(variant);
        }
        
        // AtivaPeople: variante → produto; mostrar/ocultar badge conforme mapa por variante
        const ativapeopleBadge = document.querySelector('.ativapeople-badge_new');
        const ativapeoplePriceEl = document.querySelector('.ativapeople-price');
        const ativapeopleCentsJson = document.querySelector('script[data-ativapeople-variant-cents]');
        if (ativapeopleBadge && ativapeoplePriceEl && ativapeopleCentsJson && variant.id) {
          let variantCents = {};
          try {
            variantCents = JSON.parse(ativapeopleCentsJson.textContent || '{}');
          } catch (e) {}
          const cents = variantCents[variant.id];
          if (cents != null && cents > 0) {
            ativapeopleBadge.setAttribute('data-ativapeople-fixed-cents', String(cents));
            ativapeopleBadge.style.display = '';
            ativapeoplePriceEl.textContent = formatMoney(cents);
          } else {
            ativapeopleBadge.setAttribute('data-ativapeople-fixed-cents', '0');
            ativapeopleBadge.style.display = 'none';
          }
        }

        // Also update payment terms component if it exists
        const paymentTerms = document.querySelector('shopify-payment-terms');
        if (paymentTerms && variant.id) {
          paymentTerms.setAttribute('variant-id', variant.id);
        }

        // Sticky add-to-cart bar (outra section): mesmo preço da variante que o PDP
        const stickyCurrent = document.querySelector('#sticky-add-to-cart .sticky-bar-price-current');
        const stickyCompareWrap = document.querySelector('#sticky-add-to-cart .sticky-bar-price-compare-wrap');
        const stickyCompare = document.querySelector('#sticky-add-to-cart .sticky-bar-price-compare');
        if (stickyCurrent) {
          stickyCurrent.textContent = formatMoney(variant.price);
        }
        if (stickyCompare && stickyCompareWrap) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            stickyCompare.textContent = formatMoney(variant.compare_at_price);
            stickyCompareWrap.style.display = '';
          } else {
            stickyCompareWrap.style.display = 'none';
          }
        }
      },
      
      updateMainImageForVariant(variant) {
        ProductGallery.filterMediaForVariant(variant);
      }
    };
    
    window.updateVariant = () => ProductVariants.updateVariant();
    
    // ====================================================================
    // ADD TO CART FUNCTION
    // ====================================================================
    
    const readCartError = async (response) => {
      const text = await response.text();
      try {
        return JSON.parse(text);
      } catch (e) {
        return {
          message: text ? text.slice(0, 200) : response.statusText,
          status: response.status
        };
      }
    };

    const addToCart0722 = async function() {
      // Get variant ID from form or selector
      const variantInput = document.getElementById(`product-variant-id-${productMainConfig.sectionId}`);
      const variantSelector = getVariantSelector();
      let variantId = null;
      
      if (variantInput) {
        variantId = parseInt(variantInput.value);
      } else if (variantSelector) {
        variantId = parseInt(variantSelector.value);
      } else {
        variantId = ProductVariants.variants[0]?.id || productMainConfig.selectedVariantId;
      }
      
      const quantity = parseInt(getQuantityInput()?.value || 1);
      const btn = getAddToCartButton();
      
      if (!variantId) {
        alert('Please select a product variant');
        return;
      }

      if (!btn) {
        console.error('Add to cart button not found for section', productMainConfig.sectionId);
        return;
      }
      
      // Prevent multiple submissions
      if (btn.dataset.processing === 'true') {
        return;
      }
      
      const originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;
      btn.style.opacity = '0.7';
      btn.dataset.processing = 'true';
      
      // Use variant data already embedded in the page. This avoids an extra
      // /variants/{id}.js network request and avoids parsing formatted prices.
      const selectedVariant = ProductVariants.variants.find(
        variant => Number(variant.id) === Number(variantId)
      );

      let discountInfo = null;
      if (
        selectedVariant &&
        selectedVariant.compare_at_price &&
        selectedVariant.compare_at_price > selectedVariant.price
      ) {
        discountInfo = {
          originalPrice: selectedVariant.compare_at_price,
          currentPrice: selectedVariant.price,
          savings: selectedVariant.compare_at_price - selectedVariant.price,
          percentage: Math.round(
            ((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100
          )
        };
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity }]
          })
        });
        
        if (!response.ok) {
          const error = await readCartError(response);
          console.error('Shopify cart/add.js error:', error);
          throw new Error(error.message || 'Error adding to cart');
        }
        
        const data = await response.json();
        
        // ====================================================================
        // STORE DISCOUNT INFO FOR THIS VARIANT
        // ====================================================================
        if (discountInfo && data.items && data.items.length > 0) {
          if (!window.cartDiscountData) {
            window.cartDiscountData = new Map();
          }
          
          // Get the variant ID from the response (first item)
          const addedItem = data.items[0];
          const addedVariantId = addedItem.variant_id || addedItem.id;
          
          window.cartDiscountData.set(addedVariantId.toString(), discountInfo);
        }
        // ====================================================================
        
        // Refresh cart UI once. Avoid duplicate /cart.js and drawer reload requests.
        if (window.cartDrawer) {
          await window.cartDrawer.loadCartData();
          if (typeof window.cartDrawer.updateCartCount === 'function') {
            window.cartDrawer.updateCartCount();
          }
          if (typeof window.cartDrawer.updateRecommendedSection === 'function') {
            await window.cartDrawer.updateRecommendedSection();
          }
        } else {
          const cartData = await fetch(
            `${window.Shopify?.routes?.root || '/'}cart.js`
          ).then(res => res.json());

          const cartCountElement = document.querySelector('.header__cart-count');
          if (cartCountElement) {
            cartCountElement.textContent = cartData.item_count;
          }

          if (typeof window.updateCartCount === 'function') {
            window.updateCartCount();
          }
        }
        
        // Show success notification FIRST
        if (window.CartNotification) {
          window.CartNotification.success({
            title: "Product Added!",
            message: 'Join <a href="https://www.ativafit.com/pages/ativapeople-rewards-program" target="_blank" style="color: #eb701f; text-decoration: underline; font-weight: bold;">AtivaPeople</a> & get 10% off your first order.',
            type: "success"
          });
        }
        
        // Wait for notification to appear, then open cart drawer
        setTimeout(() => {
          if (window.cartDrawer) {
            window.cartDrawer.open();
          } else if (window.theme && window.theme.miniCart) {
            window.theme.miniCart.open();
          }
        }, 300);
        
        btn.textContent = 'ADDED ✓';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.style.opacity = '1';
          delete btn.dataset.processing;
        }, 2000);
        
      } catch (error) {
        console.error('Add to cart error:', error);
        
        // Show error notification
        if (window.CartNotification) {
          window.CartNotification.error('Unable to add product to cart. Please try again.', 'Error adding product');
        } else {
          alert('Error adding product to cart. Please try again.');
        }
        
        btn.textContent = originalText;
        btn.disabled = false;
        btn.style.opacity = '1';
        delete btn.dataset.processing;
      }
    };

    window.addToCart = addToCart0722;
    
    // ====================================================================
    // BUY IT NOW FUNCTION - Goes directly to checkout
    // ====================================================================
    
    const buyItNow0722 = async function() {
      // Get variant ID from form or selector
      const variantInput = document.getElementById(`product-variant-id-${productMainConfig.sectionId}`);
      const variantSelector = getVariantSelector();
      let variantId = null;
      
      if (variantInput) {
        variantId = parseInt(variantInput.value);
      } else if (variantSelector) {
        variantId = parseInt(variantSelector.value);
      } else {
        variantId = ProductVariants.variants[0]?.id || productMainConfig.selectedVariantId;
      }
      
      const quantity = parseInt(getQuantityInput()?.value || 1);
      const btn = getBuyItNowButton();
      
      if (!variantId) {
        alert('Please select a product variant');
        return;
      }

      if (!btn) {
        console.error('Buy it now button not found for section', productMainConfig.sectionId);
        return;
      }

      if (btn.dataset.processing === 'true') {
        return;
      }
      
      const originalText = btn.textContent;
      btn.textContent = 'PROCESSING...';
      btn.disabled = true;
      btn.style.opacity = '0.7';
      btn.dataset.processing = 'true';
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity }]
          })
        });
        
        if (!response.ok) {
          const error = await readCartError(response);
          console.error('Shopify buy it now cart/add.js error:', error);
          throw new Error(error.message || 'Error adding to cart');
        }
        
        // Redirect to checkout immediately
        window.location.href = '/checkout';
        
      } catch (error) {
        console.error('Buy It Now error:', error);
        alert('Error processing your order. Please try again.');
        btn.textContent = originalText;
        btn.disabled = false;
        btn.style.opacity = '1';
        delete btn.dataset.processing;
      }
    };

    window.buyItNow = buyItNow0722;

    // Keep product accordion behavior aligned with the live theme editor version.
    window.toggleAccordion = function(header) {
      if (!header) return;

      const currentItem = header.closest('.accordion-item_new');
      const currentContent = header.nextElementSibling;
      const currentIcon = header.querySelector('.accordion-icon_new');

      if (!currentContent) return;

      const isOpen =
        header.classList.contains('active_new') ||
        currentContent.classList.contains('active_new') ||
        header.getAttribute('aria-expanded') === 'true';

      const accordionRoot =
        header.closest('.product-accordion_new') ||
        header.closest('[data-section-type="product-main"]') ||
        document;

      accordionRoot
        .querySelectorAll('.accordion-header_new')
        .forEach(function(itemHeader) {
          const item = itemHeader.closest('.accordion-item_new');
          const content = itemHeader.nextElementSibling;
          const icon = itemHeader.querySelector('.accordion-icon_new');

          itemHeader.classList.remove('active_new');
          itemHeader.setAttribute('aria-expanded', 'false');
          if (item) item.classList.remove('accordion-item-active_new');
          if (content) {
            content.classList.remove('active_new');
            content.style.maxHeight = '0px';
          }
          if (icon) icon.textContent = '+';
        });

      if (!isOpen) {
        header.classList.add('active_new');
        header.setAttribute('aria-expanded', 'true');
        if (currentItem) currentItem.classList.add('accordion-item-active_new');
        currentContent.classList.add('active_new');
        currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
        if (currentIcon) currentIcon.textContent = '-';
      }
    };

    const initializeUgcVideos0722 = () => {
      const root = document.querySelector('[data-section-type="product-main"]');
      if (!root || root.dataset.ugcInitialized0722 === 'true') return;
      root.dataset.ugcInitialized0722 = 'true';

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-ugc-play-0722]');
        if (!button || !root.contains(button)) return;

        const card = button.closest('[data-ugc-card-0722]');
        if (!card) return;

        const video = card.querySelector('video');
        if (video) {
          if (video.dataset.sourcesReady !== 'true') {
            video.querySelectorAll('source[data-src]').forEach((source) => {
              source.src = source.dataset.src;
              source.removeAttribute('data-src');
            });
            video.dataset.sourcesReady = 'true';
            video.load();
          }

          card.classList.add('is-playing');
          video.controls = true;
          video.play().catch(() => card.classList.remove('is-playing'));
          return;
        }

        if (card.querySelector('[data-ugc-external-0722]')) {
          card.classList.add('is-playing');
        }
      });
    };
    
    // ====================================================================
    // INITIALIZATION
    // ====================================================================
    
    document.addEventListener('DOMContentLoaded', () => {
      ProductGallery.init();
      initializeUgcVideos0722();
      
      // Initialize variant selector event listeners (both desktop and mobile)
      const variantSelectorDesktop = getVariantSelector();
      const variantSelectorMobile = getMobileVariantSelector();
      
      // Function to sync both selectors
      const syncVariantSelectors = (sourceSelector, targetSelector) => {
        if (targetSelector && sourceSelector) {
          targetSelector.value = sourceSelector.value;
        }
      };
      
      // Initialize desktop selector
      if (variantSelectorDesktop) {
        variantSelectorDesktop.addEventListener('change', (e) => {
          e.preventDefault();
          ProductVariants.updateVariant(variantSelectorDesktop);
        });
        
        // Initialize price with current selected variant
        const currentVariantId = parseInt(variantSelectorDesktop.value);
        const currentVariant = ProductVariants.variants.find(v => v.id === currentVariantId);
        if (currentVariant) {
          ProductVariants.updateVariant(variantSelectorDesktop);
        }
      }
      
      // Initialize mobile selector
      if (variantSelectorMobile) {
        variantSelectorMobile.addEventListener('change', (e) => {
          e.preventDefault();
          ProductVariants.updateVariant(variantSelectorMobile);
        });
        
        // Sync initial value from desktop if mobile exists
        if (variantSelectorDesktop) {
          variantSelectorMobile.value = variantSelectorDesktop.value;
        }
      }
      
      // If no desktop selector, initialize buttons (e preço sticky) com primeira variante disponível
      if (!variantSelectorDesktop && ProductVariants.variants.length > 0) {
        const firstVariant = ProductVariants.variants.find(v => v.available) || ProductVariants.variants[0];
        if (firstVariant) {
          if (variantSelectorMobile) {
            variantSelectorMobile.value = String(firstVariant.id);
            ProductVariants.updateVariant(variantSelectorMobile);
          } else {
            ProductGallery.filterMediaForVariant(firstVariant);
            ProductVariants.updatePrice(firstVariant);
            ProductVariants.updateButtonsForVariant(firstVariant);
            ProductVariants.updateProductForm(firstVariant);
          }
        }
      }
      
      // ====================================================================
      // KLAVIYO WAITLIST BUTTON TRIGGER (Must be before form submit handler)
      // ====================================================================
      // Following Klaviyo documentation: https://help.klaviyo.com/hc/en-us/articles/4418052317339
      const waitlistButtons = document.querySelectorAll('.klaviyo_waitlist_trigger');
      
      if (waitlistButtons.length > 0) {
        waitlistButtons.forEach(function(waitlistButton) {
          let formId = waitlistButton.getAttribute('data-klaviyo-form-id');
          
          if (formId && formId.trim() !== '') {
            // Extract Form ID if user accidentally pasted the full JavaScript code
            // Look for pattern like ['openForm', 'Sr3xAi'] or "Sr3xAi" or 'Sr3xAi'
            const formIdMatch = formId.match(/['"]([A-Za-z0-9]{6})['"]/);
            if (formIdMatch) {
              formId = formIdMatch[1];
            }
            
            // Clean up: remove any JavaScript code, keep only the ID
            formId = formId.trim();
            
            // Final validation: Form ID should be 6 alphanumeric characters
            if (formId.length === 6 && /^[A-Za-z0-9]+$/.test(formId)) {
              waitlistButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                
                // Initialize Klaviyo onsite array if it doesn't exist
                window._klOnsite = window._klOnsite || [];
                
                // Push the openForm command
                window._klOnsite.push(['openForm', formId]);
                
                
                return false;
              }, true); // Use capture phase to ensure it runs first
            } else {
              console.error('Invalid Klaviyo Form ID. Expected 6 alphanumeric characters (e.g., Sr3xAi). Got:', formId);
              console.warn('Please enter only the Form ID (6 characters) in the "Klaviyo Form ID" field, not the JavaScript code.');
            }
          } else {
            console.warn('Klaviyo Form ID is not configured for waitlist button.');
          }
        });
      }
      
      // Intercept form submission to prevent redirect to /cart
      const productForm = getProductForm();
      if (productForm) {
        productForm.addEventListener('submit', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Don't prevent if it's a waitlist button click
          const clickedButton = e.target.querySelector('.klaviyo_waitlist_trigger:active, .klaviyo_waitlist_trigger:focus');
          if (clickedButton) {
            return; // Let the waitlist handler deal with it
          }
          
          // Prevent multiple submissions
          if (productForm.dataset.processing === 'true') {
            return;
          }
          
          productForm.dataset.processing = 'true';
          
          // Call addToCart function
          await addToCart0722();
          
          // Remove processing flag after a delay
          setTimeout(() => {
            delete productForm.dataset.processing;
          }, 2000);
        });
      }
      
      // Ensure shopify-payment-terms component is displayed in product form
      const ensurePaymentTermsVisible = () => {
        const paymentTerms = querySection('.payment-options-form shopify-payment-terms, .product-form_new shopify-payment-terms');
        if (paymentTerms) {
          // Force component to be visible
          paymentTerms.style.display = 'block';
          paymentTerms.style.visibility = 'visible';
          paymentTerms.style.opacity = '1';
        }
      };
      
      ensurePaymentTermsVisible();
      // Also check after a delay in case Shopify scripts load later
      setTimeout(ensurePaymentTermsVisible, 1000);

      const buybox0722 = querySection('.product-buybox-0722');
      if (buybox0722) {
        const variantSelector0722 = getVariantSelector();
        const imageSwatches0722 = buybox0722.querySelectorAll('[data-variant-id-0722]');
        const textOptionButtons0722 = buybox0722.querySelectorAll('.variant-text-button-0722[data-option-index-0722]');
        const selectedOption0722 = buybox0722.querySelector('[data-selected-option-0722]');
        const qtyInput0722 = getQuantityInput();
        const qtyMinus0722 = buybox0722.querySelector('[data-qty-minus-0722]');
        const qtyPlus0722 = buybox0722.querySelector('[data-qty-plus-0722]');
        const buyItNowButton0722 = buybox0722.querySelector('[data-buy-it-now-0722]');
        const modelProductButtons0722 = buybox0722.querySelectorAll('[data-model-product-id-0722]');
        const nativeVariantWrapper0722 = buybox0722.querySelector('.variant-selector-wrapper-0722');
        const pageProductId0722 = String(productMainConfig.productId || '');

        function formatModelMoney0722(cents) {
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            const moneyFormat = window.theme?.moneyFormat || window.Shopify?.money_format || ('$' + '{' + '{amount}' + '}');
            return window.Shopify.formatMoney(cents, moneyFormat);
          }
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format((Number(cents) || 0) / 100);
        }

        function selectModelProduct0722(button) {
          if (!button) return;

          const productId = button.getAttribute('data-model-product-id-0722') || '';
          const productHandle = button.getAttribute('data-model-product-handle-0722') || '';
          const productTitle = button.getAttribute('data-model-product-title-0722') || '';
          const variantId = Number(button.getAttribute('data-model-variant-id-0722'));
          const price = Number(button.getAttribute('data-model-price-0722')) || 0;
          const compareAtPrice = Number(button.getAttribute('data-model-compare-at-price-0722')) || 0;
          const available = button.getAttribute('data-model-available-0722') === 'true';
          const rating = button.getAttribute('data-model-rating-0722') || '';
          const reviewCount = Number(button.getAttribute('data-model-review-count-0722')) || 0;

          if (!productId || !variantId) return;

          modelProductButtons0722.forEach(function(modelButton) {
            const isActive = modelButton === button;
            modelButton.classList.toggle('is-active', isActive);
            modelButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          const selectedModelVariant = {
            id: variantId,
            price: price,
            compare_at_price: compareAtPrice,
            available: available,
            title: productTitle,
            options: []
          };

          ProductVariants.updateProductForm(selectedModelVariant);
          ProductVariants.updateDynamicCheckout(selectedModelVariant);
          ProductVariants.updateButtonsForVariant(selectedModelVariant);
          ProductGallery.setModelProductMedia(productId, variantId);

          sectionRoot.querySelectorAll('.product-price_new').forEach(function(element) {
            element.textContent = formatModelMoney0722(price);
          });

          sectionRoot.querySelectorAll('.product-price-original_new').forEach(function(element) {
            if (compareAtPrice > price) {
              element.textContent = formatModelMoney0722(compareAtPrice);
              element.style.display = '';
            } else {
              element.style.display = 'none';
            }
          });

          sectionRoot.querySelectorAll('.product-save-badge-0722').forEach(function(element) {
            if (compareAtPrice > price) {
              const discountPercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
              element.textContent = String(productMainSettings.discountBadgePrefix || 'Save') + ' ' + discountPercent + '%';
              element.style.display = 'inline-flex';
            } else {
              element.style.display = 'none';
            }
          });

          const ratingLink = buybox0722.querySelector('.product-review-0722');
          const ratingText = buybox0722.querySelector('.product-review-0722__text');
          if (ratingLink && ratingText) {
            if (rating && reviewCount > 0) {
              ratingText.textContent = rating + ' (' + reviewCount + ' Reviews)';
              ratingLink.hidden = false;
              ratingLink.setAttribute('data-product-id', productId);
              ratingLink.setAttribute('data-product-handle', productHandle);
              ratingLink.setAttribute('aria-label', 'Read ' + reviewCount + ' reviews for ' + productTitle);
            } else {
              ratingLink.hidden = true;
            }
          }

          if (nativeVariantWrapper0722) {
            nativeVariantWrapper0722.hidden = productId !== pageProductId0722;
          }

          const stickyCurrent = document.querySelector('#sticky-add-to-cart .sticky-bar-price-current');
          const stickyCompareWrap = document.querySelector('#sticky-add-to-cart .sticky-bar-price-compare-wrap');
          const stickyCompare = document.querySelector('#sticky-add-to-cart .sticky-bar-price-compare');
          if (stickyCurrent) stickyCurrent.textContent = formatModelMoney0722(price);
          if (stickyCompare && stickyCompareWrap) {
            if (compareAtPrice > price) {
              stickyCompare.textContent = formatModelMoney0722(compareAtPrice);
              stickyCompareWrap.style.display = '';
            } else {
              stickyCompareWrap.style.display = 'none';
            }
          }

          document.dispatchEvent(new CustomEvent('ativafit:model-change', {
            detail: {
              productId: productId,
              productHandle: productHandle,
              productTitle: productTitle,
              variantId: variantId
            }
          }));
        }

        modelProductButtons0722.forEach(function(button) {
          button.addEventListener('click', function(event) {
            event.preventDefault();
            selectModelProduct0722(button);
          });
        });

        const initialModelButton0722 = buybox0722.querySelector('[data-model-product-id-0722].is-active');
        if (initialModelButton0722) {
          selectModelProduct0722(initialModelButton0722);
        }

        if (buyItNowButton0722) {
          buyItNowButton0722.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            buyItNow0722();
          });
        }

        function findVariantByOptions0722(optionValues, availableOnly = false) {
          return ProductVariants.variants.find(function(candidate) {
            if (availableOnly && !candidate.available) return false;
            if (!candidate.options || candidate.options.length !== optionValues.length) return false;
            return candidate.options.every(function(value, index) {
              return String(value) === String(optionValues[index]);
            });
          }) || null;
        }

        function updateTextOptionAvailability0722(variant) {
          if (!variant || !textOptionButtons0722.length) return;

          textOptionButtons0722.forEach(function(button) {
            const optionIndex = parseInt(button.getAttribute('data-option-index-0722'), 10);
            const optionValue = button.getAttribute('data-option-value-0722');
            const candidateOptions = variant.options.slice();
            candidateOptions[optionIndex] = optionValue;

            const availableVariant = findVariantByOptions0722(candidateOptions, true);
            const isActive = String(variant.options[optionIndex]) === String(optionValue);
            const isAvailable = !!availableVariant || isActive;

            button.disabled = !isAvailable;
            button.classList.toggle('is-unavailable', !isAvailable);
            button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
          });
        }

        function syncUnifiedVariantReviews0722(variant) {
          if (
            !variantSelector0722 ||
            !variant ||
            buybox0722.getAttribute('data-unified-product-variants-0722') !== 'true'
          ) return;

          const mappedOption = Array.from(variantSelector0722.options).find(function(option) {
            return String(option.value) === String(variant.id);
          });
          if (!mappedOption) return;

          const productId = mappedOption.getAttribute('data-review-product-id-0722') || '';
          const productHandle = mappedOption.getAttribute('data-review-product-handle-0722') || '';
          const productTitle = mappedOption.getAttribute('data-review-product-title-0722') || '';
          const rating = mappedOption.getAttribute('data-review-rating-0722') || '';
          const reviewCount = Number(mappedOption.getAttribute('data-review-count-0722')) || 0;
          if (!productId) return;

          const ratingLink = buybox0722.querySelector('.product-review-0722');
          const ratingText = buybox0722.querySelector('.product-review-0722__text');
          if (ratingLink && ratingText) {
            if (rating && reviewCount > 0) {
              ratingText.textContent = rating + ' (' + reviewCount + ' Reviews)';
              ratingLink.hidden = false;
              ratingLink.setAttribute('data-product-id', productId);
              ratingLink.setAttribute('data-product-handle', productHandle);
              ratingLink.setAttribute('aria-label', 'Read ' + reviewCount + ' reviews for ' + productTitle);
            } else {
              ratingLink.hidden = true;
            }
          }

          document.dispatchEvent(new CustomEvent('ativafit:model-change', {
            detail: {
              productId: productId,
              productHandle: productHandle,
              productTitle: productTitle,
              variantId: variant.id
            }
          }));
        }

        window.updateBuybox0722Variant = function(variant) {
          if (!variant) return;

          imageSwatches0722.forEach(function(swatch) {
            const isActive = String(swatch.getAttribute('data-variant-id-0722')) === String(variant.id);
            swatch.classList.toggle('is-active', isActive);
            swatch.setAttribute('aria-checked', isActive ? 'true' : 'false');
            if (isActive && selectedOption0722) {
              selectedOption0722.textContent = swatch.getAttribute('data-variant-label-0722') || variant.title;
            }
          });

          textOptionButtons0722.forEach(function(button) {
            const optionIndex = parseInt(button.getAttribute('data-option-index-0722'), 10);
            const optionValue = button.getAttribute('data-option-value-0722');
            const isActive = String(variant.options[optionIndex]) === String(optionValue);
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });

          updateTextOptionAvailability0722(variant);
          syncUnifiedVariantReviews0722(variant);
        };

        imageSwatches0722.forEach(function(swatch) {
          swatch.addEventListener('click', function() {
            if (swatch.disabled || !variantSelector0722) return;
            variantSelector0722.value = swatch.getAttribute('data-variant-id-0722');
            ProductVariants.updateVariant(variantSelector0722);
          });
        });

        textOptionButtons0722.forEach(function(button) {
          button.addEventListener('click', function() {
            if (button.disabled || !variantSelector0722) return;

            const currentVariantId = parseInt(variantSelector0722.value, 10);
            const currentVariant = ProductVariants.variants.find(function(candidate) {
              return Number(candidate.id) === currentVariantId;
            }) || ProductVariants.variants[0];

            if (!currentVariant || !currentVariant.options) return;

            const optionIndex = parseInt(button.getAttribute('data-option-index-0722'), 10);
            const optionValue = button.getAttribute('data-option-value-0722');
            const nextOptions = currentVariant.options.slice();
            nextOptions[optionIndex] = optionValue;

            const nextVariant = findVariantByOptions0722(nextOptions, true) || findVariantByOptions0722(nextOptions, false);
            if (!nextVariant) return;

            variantSelector0722.value = String(nextVariant.id);
            ProductVariants.updateVariant(variantSelector0722);
          });
        });

        if (variantSelector0722) {
          const initialVariantId0722 = parseInt(variantSelector0722.value, 10);
          const initialVariant0722 = ProductVariants.variants.find(function(candidate) {
            return Number(candidate.id) === initialVariantId0722;
          });
          if (initialVariant0722) {
            window.updateBuybox0722Variant(initialVariant0722);
          }
        }

        function setQty0722(nextValue) {
          if (!qtyInput0722) return;
          const parsed = parseInt(nextValue, 10);
          qtyInput0722.value = Math.max(1, Number.isFinite(parsed) ? parsed : 1);
        }

        if (qtyMinus0722) {
          qtyMinus0722.addEventListener('click', function() {
            setQty0722((parseInt(qtyInput0722 && qtyInput0722.value, 10) || 1) - 1);
          });
        }

        if (qtyPlus0722) {
          qtyPlus0722.addEventListener('click', function() {
            setQty0722((parseInt(qtyInput0722 && qtyInput0722.value, 10) || 1) + 1);
          });
        }

        if (qtyInput0722) {
          qtyInput0722.addEventListener('change', function() {
            setQty0722(qtyInput0722.value);
          });
        }
      }
      
      // Hide Shop Pay button if option is enabled
      const hideShopPayButton = () => {
        const hideShopPayContainer = document.querySelector('.hide-shop-pay_new');
        if (hideShopPayContainer) {
          // Hide Shop Pay button using various selectors
          const shopPayButtons = hideShopPayContainer.querySelectorAll(
            '[data-testid="shopify-pay-button"], ' +
            '[aria-label*="Shop Pay"], ' +
            'iframe[src*="shop-pay"], ' +
            '.shopify-cleanslate [aria-label*="Shop Pay"], ' +
            '.shopify-cleanslate button[data-testid="shopify-pay-button"]'
          );
          
          shopPayButtons.forEach(btn => {
            btn.style.display = 'none';
            btn.style.visibility = 'hidden';
          });
          
          // Also hide parent containers if they only contain Shop Pay
          const shopPayIframes = hideShopPayContainer.querySelectorAll('iframe[src*="shop-pay"]');
          shopPayIframes.forEach(iframe => {
            const parent = iframe.closest('div');
            if (parent && parent.querySelectorAll('iframe').length === 1) {
              parent.style.display = 'none';
            }
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';
          });
        }
      };
      
      // Run immediately and after delays to catch dynamically loaded buttons
      hideShopPayButton();
      setTimeout(hideShopPayButton, 500);
      setTimeout(hideShopPayButton, 1500);
      setTimeout(hideShopPayButton, 3000);
      
      // Also observe for dynamically added elements
      const observer = new MutationObserver(() => {
        hideShopPayButton();
      });
      
      const dynamicCheckout = document.querySelector('.hide-shop-pay_new');
      if (dynamicCheckout) {
        observer.observe(dynamicCheckout, {
          childList: true,
          subtree: true
        });
      }
      
    });
    
  })();
